import httpClient from './httpClient'

const END_POINT = '/customerresources/user-account'

const AccountAPI = {

  /**
   * Check if seller can create ring tree targets
   * @param {string} accountId
   * @returns {Promise<{data: boolean}>}
   */
  async canCreateRingTreeTarget(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/ringba-account/ring-tree-enabled`)
  },
}

export default AccountAPI
